import { createAction } from '@ngrx/store';

export const startLoading = createAction('[UI] Start Loading');
export const stopLoading = createAction('[UI] Stop Loading'); 